import { useEffect, useMemo, useState } from "react";
import ConfigTable from "../../../Common/Tables/ConfigTable";
import { useDispatch } from "react-redux";
import {
  MP_GetApprovalMPList,
  MP_MPApprovalResponce,
} from "../../../API_Service/MeasurementProtocol_Slice";
import { companyID, employeeID } from "../../../Common/UIComponents";

function Toast({ msg, show, type = "success" }) {
  if (!show) return null;
  const isError = type === "error";
  return (
    <div
      className={`fixed top-6 left-1/2 -translate-x-1/2 z-[300] flex items-center gap-2.5 ${
        isError ? "bg-red-500" : "bg-emerald-500"
      } text-white px-5 py-3 rounded-2xl shadow-xl text-sm font-semibold pointer-events-none`}
      style={{ animation: "fadeUp .25s cubic-bezier(.4,0,.2,1)" }}
    >
      <span
        className="material-symbols-outlined text-[18px]"
        style={{ fontVariationSettings: "'FILL' 1" }}
      >
        {isError ? "error" : "check_circle"}
      </span>
      {msg}
    </div>
  );
}

const MPDashboardIndex = () => {
  const [mpList, setMPList] = useState([]);
  const dispatch = useDispatch();
  const [toast, setToast] = useState({ show: false, msg: "", type: "success" });

  const notify = (msg, type = "success") => {
    setToast({ show: true, msg, type });
    setTimeout(() => setToast((t) => ({ ...t, show: false })), 2500);
  };

  useEffect(() => {
    GetApprovalMPList();
  }, []);

  const GetApprovalMPList = () => {
    const payload = {
      companyID: companyID,
    };
    dispatch(MP_GetApprovalMPList(payload)).then((res) => {
      if (res.payload.data) {
        setMPList(res.payload.data);
      }
    });
  };

  const handleActionClick = (mpid, actionType) => {
    const payload = {
      mpID: mpid,
      status: actionType,
      modifiedBy: employeeID,
      companyID: companyID,
    };
    dispatch(MP_MPApprovalResponce(payload)).then((res) => {
      if (res?.payload?.data) {
        notify(actionType ? "Approved Successfully" : "Rejected Successfully");
        GetApprovalMPList();
      }
    });
  };

  const columns = useMemo(
    () => [
      {
        key: "MP_Code",
        title: "MP Code",
      },
      {
        key: "Facility_Name",
        title: "Facility Name",
      },
      {
        key: "Equipment_Test_Type_nm",
        title: "Test Type Name",
      },
      {
        key: "StartDate",
        title: "Start Date",
      },
      {
        key: "EndDate",
        title: "End Date",
      },
      {
        key: "Actions",
        title: "Actions",
        render: (row) => (
          <div className="flex items-center space-x-2">
            {/* Approve Button with Material Symbol (Check icon) */}
            <button
              onClick={() => handleActionClick(row.MP_Id, 1)}
              title="Approve"
              className="p-1.5 bg-green-100 text-green-700 rounded-full hover:bg-green-600 hover:text-white transition shadow-sm flex items-center justify-center"
            >
              <span className="material-symbols-outlined text-[16px]">
                check
              </span>
            </button>

            {/* Reject Button with Material Symbol (Close/X icon) */}
            <button
              onClick={() => handleActionClick(row.MP_Id, 0)}
              title="Reject"
              className="p-1.5 bg-red-100 text-red-700 rounded-full hover:bg-red-600 hover:text-white transition shadow-sm flex items-center justify-center"
            >
              <span className="material-symbols-outlined text-[16px]">
                close
              </span>
            </button>
          </div>
        ),
      },
    ],
    [],
  );

  return (
    <>
      <Toast msg={toast.msg} show={toast.show} type={toast.type} />
      <div className="mb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-6">
          <ConfigTable columns={columns} rows={mpList} />
        </div>
      </div>
    </>
  );
};

export default MPDashboardIndex;
